import { getSystem } from '../root.selectors'

export const getSystemInfo = (state) => getSystem(state).info
export const getSystemActiveUsers = (state) => getSystem(state).activeUsers
